(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      if (!reduced.matches && !document.body.classList.contains('animations-off')) entry.target.classList.add('nova-enter');
    }
  }, { threshold: .12 });
  function observe(root = document) {
    root.querySelectorAll('.atelier-intro,.atelier-edit__grid .card-product,.atelier-story__copy,.collection-nav__card,.newsletter__inner').forEach(element => {
      if (seen.has(element)) return;
      seen.add(element);
      observer.observe(element);
    });
  }
  observe();
  document.addEventListener('shopify:section:load', event => observe(event.target));
  reduced.addEventListener('change', () => {
    if (reduced.matches) document.querySelectorAll('.nova-enter').forEach(element => element.classList.remove('nova-enter'));
  });
})();
